export const ADD_ORGANIZATION = "ADD_ORGANIZATION";
export const SET_ORGANIZATIONS = "SET_ORGANIZATIONS";
export const SET_LOADED_STATUS = "SET_LOADED_STATUS";
export const UPDATE_EDITED_ORGANIZATION_VALUE =
  "UPDATE_EDITED_ORGANIZATION_VALUE";
export const SET_EDITED_ORGANIZATION = "SET_EDITED_ORGANIZATION";
export const SET_MEMBER_ORGANIZATION = "SET_MEMBER_ORGANIZATION";
export const SET_TEAMS_ORGANIZATION = "SET_TEAMS_ORGANIZATION";
export const SET_ORGANIZATION_MEMBERS_RESPONSE_OBJECT =
  "SET_ORGANIZATION_MEMBERS_RESPONSE_OBJECT";
export const SET_MOBILE_ORGANIZATION = "SET_MOBILE_ORGANIZATION";
export const SET_CHALLENGES = "SET_CHALLENGES";
export const RESET_ORGANIZATIONS_STATE = "RESET_ORGANIZATIONS_STATE";
